import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { IAppRootState } from 'src/app/core/store';

import { depotConfigReducer } from './depot-config.reducer';
import {
	DepotConfigSliceState,
	DepotConfigSliceKey,
} from './depot-config.state';
import { depotOriginalReducer } from './depot.reducer';
import { DepotOriginalSliceState, DepotSliceKey } from './depot.state';

export const DepotFeatureKey = 'Depot';

export interface DepotFeatureState {
	[DepotSliceKey]: DepotOriginalSliceState;
	[DepotConfigSliceKey]: DepotConfigSliceState;
}

export interface DepotRootState extends IAppRootState {
	[DepotFeatureKey]: DepotFeatureState;
}

export const featureSelector =
	createFeatureSelector<DepotFeatureState>(DepotFeatureKey);

export const depotReducers: ActionReducerMap<DepotFeatureState> = {
	[DepotSliceKey]: depotOriginalReducer,
	[DepotConfigSliceKey]: depotConfigReducer,
};
